import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { RegionDataType } from "../DataFetch/useRegionMaster";
import { useConfirmDialog } from "../Component/useConfirmDialog";
import { useErrorDialog } from "../Component/useErrorDialog";
import { useContext } from "react";
import { SessionContext } from "../ManagementRoot";
import { PostAddRegion, PostDeleteRegion, PostUpdateRegion } from "../DataFetch/ManagementAPI";

interface FormInputType {
    regionId:number,
    regionName:string,
}

interface PropsType {
    editData:RegionDataType | undefined,
    CompleteEdit:() => void,
    setEditing:(editing:boolean) => void    
}

export function RegionMasterEdit({editData, CompleteEdit, setEditing}:PropsType) {

    const isNew = editData === undefined ? true : false

    const {waitConfirm, ConfirmDialog} = useConfirmDialog();

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const ConfirmSession = useContext(SessionContext);

    const {control, handleSubmit } = useForm<FormInputType>({
        defaultValues:{
            regionId: editData?.region_id,
            regionName: editData?.region_name
        }
    });

    async function onSubmit(data:FormInputType) {
        
        if(!await ConfirmSession()) {
            return;
        }

        await waitConfirm("保存します。よろしいですか？")
        .then(res => {
            if(res) {
                if(isNew) {
                    PostAddRegion({
                        regionId:data.regionId,
                        regionName:data.regionName,
                    })
                    .then(res => {
                        res ? CompleteEdit() : openErrorDialog();
                    })
                } else {
                    PostUpdateRegion({
                        regionNo:Number(editData?.id),
                        regionName:data.regionName,
                    })
                    .then(res => {
                        res ? CompleteEdit() : openErrorDialog();
                    })
                }
            }
        })

    }

    async function DeleteRegion() {

        if(!await ConfirmSession()) {
            return;
        }

        await waitConfirm("削除します。よろしいですか？")
        .then(res => {
            res && PostDeleteRegion(Number(editData?.id))
            .then(res => {
                res ? CompleteEdit() : openErrorDialog();
            })
        })

    }

    return(
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            地域ID
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm="auto">
                        <Controller
                            name="regionId"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 3,
                                    message:"3桁以下にしてください。"
                                },
                                pattern: {
                                    value: /[0-9]/,
                                    message: "数字のみ入力可能です"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                    disabled={!isNew}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid2 xs={12} sm="auto">
                        <Typography variant="body1" sx={{textAlign:{xs:"none",sm:"left"}}}>
                            地域名
                        </Typography>  
                    </Grid2>
                    <Grid2 xs={12} sm="auto">
                        <Controller
                            name="regionName"
                            control={control}
                            rules={{
                                required:"必須項目です。",
                                maxLength: {
                                    value: 30,
                                    message:"30文字以下にしてください。"
                                }
                            }}
                            render={({field,fieldState}) => (
                                <TextField 
                                    {...field} 
                                    error={fieldState.invalid}
                                    helperText={fieldState.error?.message}
                                />
                            )}
                        />
                    </Grid2>
                </Grid2>
                <Box m={1}>
                    <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                        <Grid2>
                            <Button variant="outlined" onClick={() => setEditing(false)}>
                                戻る
                            </Button>
                        </Grid2>
                        <Grid2>
                            <Button type="submit" variant="contained">
                                保存
                            </Button>
                        </Grid2>
                        <Grid2 display={isNew ? "none" : ""}>
                            <Button variant="contained" color="error" onClick={DeleteRegion}>
                                削除
                            </Button>
                        </Grid2>                     
                    </Grid2>
                </Box>  
            </form>

            <ConfirmDialog/>
            <ErrorDialog/>
        </>
    );
}